<!-- Topbar Start -->
<div class="container-fluid position-fixed bg-dark p-0">
    <div class="row gx-0 d-none d-lg-flex">
      <div class="col-lg-7 px-5 text-start">
        <div class="h-100 d-inline-flex align-items-center py-3 me-4">
          <small class="fa fa-map-marker-alt text-soft-gray me-2"></small>
          <small>Monterrey, Nuevo Leon</small>
        </div>
        <div class="h-100 d-inline-flex align-items-center py-3">
          <small class="far fa-clock text-soft-gray me-2"></small>
          <small>
            {{ fecha | date: 'medium' }}
          </small>
        </div>
      </div>
      <div class="col-lg-5 px-5 text-end">
        <div class="h-100 d-inline-flex align-items-center py-3 me-4">
          <small class=" text-soft-gray me-2"></small>
          <small> </small>
        </div>
        <ng-container *ngIf="authService.authUser && authService.authUser.identificador; else elseTemplate">
          <div class="h-100 d-inline-flex align-items-center py-3 me-4">
            <a
              class="fw-medium cursor-pointer text-light-gray"
              (click)="cerrarSesion()">
              <i class="fa fa-user ms-2"></i>
              Salir
            </a>
          </div>
        </ng-container>
        <ng-template #elseTemplate>
          <div class="h-100 d-inline-flex align-items-center py-3 me-4">
            <a
              class="fw-medium cursor-pointer text-light-gray"
              (click)="showLoginModal()"
              >Acceder<i class="fa fa-arrow-right ms-2"></i
            ></a>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- Topbar End -->
  